module.exports = __webpack_public_path__ + "img/form-fb.d50ac36b.svg";